var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-top":"100px"}},[_c('BookingInfoSection',{attrs:{"BookingInfo":_vm.Bookinfomation}}),_c('UserInfoSection',{staticClass:"mt-8",on:{"callbackUserInfo":_vm.callbackUserInfo}}),_c('PurchaseMethod',{staticClass:"mt-8",attrs:{"BookingInfo":_vm.Bookinfomation,"UserInfo":_vm.Userinfomation,"token":_vm.purchaseToken}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }